import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { deleteDocumentType } from "./actions";

const DeleteDocumentType = ({ documentType, onDeleted, onCancel }) => (
  <ModalBuilder
    submitAction={deleteDocumentType}
    submitParams={documentType.id}
    onSubmitted={onDeleted}
    onCancel={onCancel}
    renderModal={(modalProps) => (
      <Modal.Confirmation {...modalProps} header="Delete Document Type">
        Are you sure you wish to delete <b>{documentType.name}</b>?
      </Modal.Confirmation>
    )}
  />
);

export default DeleteDocumentType;
